import { Routes, Route, Navigate } from "react-router-dom";
import About from './About';
import Catalog from './layout/Catalog';
import Widget  from './layout/Widget';
import EventList from './events/EventList';
import Exhibitor from './exhibitor/Exhibitor';
import Exhibitors from './exhibitors/Exhibitors';
import Activities from "./activities/Activities";
import Activity from "./activity/Activity";
import Preset from "./layout/Preset";
import Redirect from "./redirect/Redirect";

const App = () => {
	return (
        <Routes>
            <Route path='/catalog' element={<Catalog/>}>
                <Route path='about' element={<About/>}/>
                <Route path='about/:lang' element={<About/>}/>
                <Route path='events' element={<EventList/>}/>
                <Route path='exhibitor/:id' element={<Exhibitor/>}/>
                <Route path='exhibitor/:id/lang/:lang' element={<Exhibitor/>}/>
                <Route path='exhibitors/:id' element={<Exhibitors/>}/>
                <Route path='exhibitors/:id/lang/:lang' element={<Exhibitors/>}/>
                <Route path='activity/:id' element={<Activity/>}/>
                <Route path='activity/:id/lang/:lang' element={<Activity/>}/>
                <Route path='activities/:id' element={<Activities/>}/>
                <Route path='activities/:id/lang/:lang' element={<Activities/>}/>
                <Route path='preset/:lang/:event/:type/:id/:cats/:dates/:cntrs' element={<Preset/>}/>
                <Route path='redirect/exhibitor/:id' element={<Redirect/>} />
            </Route>
            <Route path='/widget' element={<Widget/>}>
                <Route path='about' element={<About/>}/>
                <Route path='about/:lang' element={<About/>}/>
                <Route path='events' element={<EventList/>}/>
                <Route path='exhibitor/:id' element={<Exhibitor/>}/>
                <Route path='exhibitor/:id/lang/:lang' element={<Exhibitor/>}/>
                <Route path='exhibitors/:id' element={<Exhibitors/>}/>
                <Route path='exhibitors/:id/lang/:lang' element={<Exhibitors/>}/>
                <Route path='activity/:id' element={<Activity/>}/>
                <Route path='activity/:id/lang/:lang' element={<Activity/>}/>
                <Route path='activities/:id' element={<Activities/>}/>
                <Route path='activities/:id/lang/:lang' element={<Activities/>}/>
                <Route path='preset/:lang/:event/:type/:id/:cats/:dates/:cntrs' element={<Preset/>}/>
                <Route path='redirect/exhibitor/:id' element={<Redirect/>} />
            </Route>
            <Route path='*' element={<Navigate replace to='/catalog'/>} />
        </Routes>
	);
};

export default App;
